export default {
  items: [
    {
      name: 'transports',
      url: '/transports',
      icon: 'truck',
      statuses: ['courierDataApproved']
    },
    {
      name: 'dashboard',
      url: '/dashboard',
      icon: 'home'
    }
  ]
}
